import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss'],
  standalone: false
})
  
/** Custom bike loading animation */
  
export class LoadingAnimationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
